import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListadoControlesBTComponent } from './listado-controles-bt/listado-controles-bt.component';
import { AuxiliaresModule } from '../../auxiliares/auxiliares.module';
import { ControlesRoutingModule } from './controles-bt.routing.module';
import { ControlesBTComponent } from './controles-bt/controles-bt.component';
import { CrearEditarControlesBTComponent } from './crear-editar-controles-bt/crear-editar-controles-bt.component';
import { CrearControlesBTComponent } from './crear-controles-bt/crear-controles-bt.component';

@NgModule({
  declarations: [
    ControlesBTComponent,
    ListadoControlesBTComponent,
    CrearEditarControlesBTComponent,
    CrearControlesBTComponent,
  ],
  imports: [CommonModule, AuxiliaresModule, ControlesRoutingModule],
})
export class ControlesBTModule {}
